import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar, Alert, Typography, Modal, Drawer } from "antd";
import { UserOutlined, PhoneOutlined, WhatsAppOutlined, MailOutlined } from "@ant-design/icons";
import CustomButton from "Components/CustomButton";
import { IsNullUndefinedEmpty } from "utils/helper";
import styled from "styled-components";
const { Text, Paragraph } = Typography;
const ProducerContacts = ({ producer, customStyle, linkColor }) => {
  const { t } = useTranslation();
  try {
    if (!producer) return <></>;

    <style>
      {`
      .salespark-paragraph {
         color: var(--button-color) !important;
         margin-bottom: 8px;
      }
      .salespark-paragraph .ant-typography-copy  {
        color: var(--button-color) !important;
      }
       
    `}
    </style>;

    let supportEmail = producer?.email;

    if (IsNullUndefinedEmpty(supportEmail)) {
      return (
        <Alert
          message={t("support.loadError")}
          description={t("support.loadErrorDescription")}
          type="error"
          showIcon
        />
      );
    }

    return (
      <>
        <div className="mb-2" style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
          {producer?.picture ? (
            <Avatar size={32} src={producer.picture} />
          ) : (
            <Avatar size={32} icon={<UserOutlined />} />
          )}
          <div>
            <h3 className="ml-2 mb-0">{producer?.name}</h3>
          </div>
        </div>

        <div style={{ "--salespark-paragraph-anticon": linkColor }}>
          <style>
            {`.salespark-paragraph { margin-bottom: 8px; }.salespark-paragraph .ant-typography-copy  { color: var(--salespark-paragraph-anticon) !important; }`}
          </style>
          <Paragraph
            className="salespark-paragraph"
            copyable={{ tooltips: [t("support.copyEmail"), t("support.copied")], text: supportEmail }}
          >
            <MailOutlined /> <strong>{t("support.emailFullLabel")} </strong> {supportEmail}
          </Paragraph>
        </div>

        {producer?.support_phone?.length > 5 && (
          <div style={{ "--salespark-paragraph-anticon": linkColor }}>
            <style>
              {`.salespark-paragraph { margin-bottom: 8px; }.salespark-paragraph .ant-typography-copy  { color: var(--salespark-paragraph-anticon) !important; }`}
            </style>
            <Paragraph
              className="salespark-paragraph"
              copyable={{ tooltips: [t("support.copyPhone"), t("support.copied")], text: producer.support_phone }}
            >
              <PhoneOutlined /> <strong>{t("support.phoneFullLabel")} </strong>
              <a
                rel="noreferrer"
                target="_blank"
                href={`tel:${producer.support_phone}`}
                style={{ color: linkColor }}
              >
                {producer.support_phone.match(/.{1,3}/g).join(" ")}
              </a>
            </Paragraph>
          </div>
        )}

        {producer?.support_whatsapp?.length > 5 && (
          <div style={{ "--salespark-paragraph-anticon": linkColor }}>
            <style>
              {`.salespark-paragraph { margin-bottom: 8px; }.salespark-paragraph .ant-typography-copy  { color: var(--salespark-paragraph-anticon) !important; }`}
            </style>
            <Paragraph
              className="salespark-paragraph"
              copyable={{ tooltips: [t("support.copyWhatsapp"), t("support.copied")], text: producer.support_whatsapp }}
            >
              <WhatsAppOutlined /> <strong>{t("support.whatsappFullLabel")} </strong>
              <a
                rel="noreferrer"
                target="_blank"
                href={`https://wa.me/${producer.support_whatsapp?.replace("+", "")}`}
                style={{ color: linkColor }}
              >
                {producer.support_whatsapp.match(/.{1,3}/g).join(" ")}
              </a>
            </Paragraph>
          </div>
        )}
      </>
    );

    // Error handling
  } catch (error) {
    console.error("Error in ProducerContacts: ", error);
    return (
      <Alert
        message={t("support.loadError")}
        description={t("support.loadErrorDescription")}
        type="error"
        showIcon
      />
    );
  }
};

// Modern producer-contact card (used in the mobile bottom drawer): green hero
// with avatar + name, then contact rows with icon chips + copy.
const ProducerContactCard = ({ producer, customStyle }) => {
  const { t } = useTranslation();
  if (!producer || !producer?.email) return <></>;

  const accent = customStyle?.primary?.backgroundColor;

  const initialsOf = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] || "";
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] || "" : "";
    return (first + last).toUpperCase();
  };
  const fmt = (v) => `+${v.match(/.{1,3}/g).join(" ")}`;
  const hasPhone = producer?.support_phone && producer?.support_phone?.length > 5;
  const hasWhatsapp = producer?.support_whatsapp && producer?.support_whatsapp?.length > 5;

  return (
    <div className="pcd" style={accent ? { "--pcd-accent": accent } : undefined}>
      <div className="pcd__hero">
        <div className="pcd__glow" aria-hidden="true" />
        {producer?.picture ? (
          <img className="pcd__avatar pcd__avatar--img" src={producer.picture} alt="" />
        ) : (
          <div className="pcd__avatar">{initialsOf(producer?.name)}</div>
        )}
        <div className="pcd__eyebrow">{t("support.contactProducer")}</div>
        <div className="pcd__name">{producer?.name}</div>
      </div>

      <div className="pcd__list">
        <a className="pcd__row" rel="noreferrer" target="_blank" href={`mailto:${producer?.email}`}>
          <span className="pcd__icon pcd__icon--mail" aria-hidden="true">
            <MailOutlined />
          </span>
          <span className="pcd__body">
            <span className="pcd__label">{t("support.emailFullLabel")}</span>
            <span className="pcd__value">{producer?.email}</span>
          </span>
          <Text
            className="pcd__copy"
            copyable={{ tooltips: [t("support.copyEmail"), t("support.copied")], text: producer?.email }}
            onClick={(e) => e.stopPropagation()}
          />
        </a>

        {hasPhone && (
          <a className="pcd__row" rel="noreferrer" target="_blank" href={`tel:${producer.support_phone}`}>
            <span className="pcd__icon pcd__icon--phone" aria-hidden="true">
              <PhoneOutlined />
            </span>
            <span className="pcd__body">
              <span className="pcd__label">{t("support.phoneFullLabel")}</span>
              <span className="pcd__value">{fmt(producer.support_phone)}</span>
            </span>
            <Text
              className="pcd__copy"
              copyable={{ tooltips: [t("support.copyPhone"), t("support.copied")], text: producer.support_phone }}
              onClick={(e) => e.stopPropagation()}
            />
          </a>
        )}

        {hasWhatsapp && (
          <a
            className="pcd__row"
            rel="noreferrer"
            target="_blank"
            href={`https://wa.me/${producer.support_whatsapp?.replace("+", "")}`}
          >
            <span className="pcd__icon pcd__icon--whatsapp" aria-hidden="true">
              <WhatsAppOutlined />
            </span>
            <span className="pcd__body">
              <span className="pcd__label">{t("support.whatsappFullLabel")}</span>
              <span className="pcd__value">{fmt(producer.support_whatsapp)}</span>
            </span>
            <Text
              className="pcd__copy"
              copyable={{ tooltips: [t("support.copyWhatsapp"), t("support.copied")], text: producer.support_whatsapp }}
              onClick={(e) => e.stopPropagation()}
            />
          </a>
        )}
      </div>
    </div>
  );
};

const Producer = ({ data, isMobile, customStyle }) => {
  const { t } = useTranslation();
  const linkColor = customStyle?.link?.linkColor;
  const hoverLinkColor = customStyle?.link?.hoverLinkColor;

  const StyledSpan = styled.span`
    display: inline-block;
    cursor: pointer;
    text-decoration: underline;
    color: ${linkColor};
    cursor: pointer;

    &:hover {
      color: ${hoverLinkColor};
      text-decoration: none;
    }
  `;

  const [showProducerModal, setShowProducerModal] = useState(false);

  const Initials = ({ name }) => {
    name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const short_name = name.replace(/([a-z]+) .* ([a-z]+)/i, "$1 $2");
    return short_name.match(/\b\w/g).join("");
  };

  return (
    <>
      <div className="producer-container" style={customStyle?.primary?.backgroundColor ? { "--prod-accent": customStyle.primary.backgroundColor } : undefined}>
        <Avatar
          size="small"
          src={data?.producer?.picture}
          icon={<UserOutlined />}
          onClick={() => setShowProducerModal(true)}
          style={{ backgroundColor: customStyle?.primary?.backgroundColor || "#f56a00", cursor: "pointer" }}
        >
          <Initials name={data?.producer?.name} />
        </Avatar>

        <div className="producer">
          <div>
            <Text className="producer-name">
              <strong>{t("support.producerLabel")}</strong>{" "}
              <StyledSpan onClick={() => setShowProducerModal(true)}>{data?.producer?.name}</StyledSpan>
            </Text>
          </div>
        </div>
      </div>
      {!isMobile && (
        <Modal
          wrapClassName="producer-contact-modal2"
          visible={showProducerModal}
          title={null}
          width={440}
          onCancel={() => setShowProducerModal(false)}
          footer={
            <div className="pcd-footer">
              <CustomButton
                customStyle={customStyle}
                type="primary"
                key="back"
                onClick={() => setShowProducerModal(false)}
              >
                {t("support.close")}
              </CustomButton>
            </div>
          }
        >
          <ProducerContactCard producer={data?.producer} customStyle={customStyle} />
        </Modal>
      )}
      {isMobile && (
        <Drawer
          className="producer-contact-drawer"
          title={null}
          height="auto"
          placement="bottom"
          closable={true}
          onClose={() => setShowProducerModal(false)}
          visible={showProducerModal}
          footer={
            <div className="pcd-footer">
              <CustomButton
                customStyle={customStyle}
                type="primary"
                key="back"
                onClick={() => setShowProducerModal(false)}
              >
                {t("support.close")}
              </CustomButton>
            </div>
          }
        >
          <ProducerContactCard producer={data?.producer} customStyle={customStyle} />
        </Drawer>
      )}
    </>
  );
};

export default Producer;
